import type { OnboardingTemplate } from 'src/interfaces/onboardingTemplate'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getOnboardingTemplates = (state: State): OnboardingTemplate[] => {
  return state.onboardingTemplateList.templates
}

export const getOnboardingTemplatesLoading = (state: State): boolean => {
  return state.onboardingTemplateList.templatesLoading
}

export const getOnboardingTemplatesError = (state: State): string | null => {
  return state.onboardingTemplateList.templatesError
}

export const getOnboardingTemplateSaving = (state: State): boolean => {
  return state.onboardingTemplateList.saving
}

export const getOnboardingTemplateDeletingId = (state: State): string | null => {
  return state.onboardingTemplateList.deletingId
}
